import _defineProperty from "/var/jenkins_home/workspace/tingle.94607f31-7a2e-4abf-8415-c7d1efa27784/workspace/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

// ignore-string-externalization
import React from 'react';
import qs from 'query-string';
import { ImageAspectBox16x9 } from './Box';
import { jsx as _jsx } from "react/jsx-runtime";
export var VideoComponent = function VideoComponent(_ref) {
  var _ref$url = _ref.url,
      url = _ref$url === void 0 ? '' : _ref$url,
      _ref$wrapper = _ref.wrapper,
      wrapper = _ref$wrapper === void 0 ? true : _ref$wrapper,
      width = _ref.width,
      height = _ref.height,
      iframeStyle = _ref.iframeStyle,
      _ref$wrapperStyle = _ref.wrapperStyle,
      wrapperStyle = _ref$wrapperStyle === void 0 ? {} : _ref$wrapperStyle;

  function videoId(videoUrl) {
    var regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
    var match = videoUrl.match(regExp);
    return match && match[2].length === 11 ? match[2] : null;
  }

  var embedUrl = "https://www.youtube.com/embed/".concat(videoId(url), "?").concat(qs.stringify({
    autoplay: 0,
    iv_load_policy: 3,
    playsinline: 1,
    rel: 0,
    showinfo: 0
  }));
  var params = {};
  if (width) params.width = width;
  if (height) params.height = height;
  if (iframeStyle) params.style = iframeStyle;

  var frame = /*#__PURE__*/_jsx("iframe", _objectSpread({
    title: "video",
    src: embedUrl,
    frameBorder: "0",
    allowFullScreen: true,
    allow: "encrypted-media"
  }, params));

  if (wrapper) {
    return /*#__PURE__*/_jsx(ImageAspectBox16x9, {
      "data-testid": "video-component",
      style: wrapperStyle,
      children: frame
    });
  }

  return frame;
};